export const isArrayEqual = (arr1: unknown, arr2: unknown) =>
  JSON.stringify(arr1) === JSON.stringify(arr2);

export const getNavId = (...args: (string | number)[]) => args.join('-');
